.root {
  display: inline-flex;
  align-items: center;
}

.trigger {
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: var(--radius-round);
}

.list {
  min-width: 240px;
}

.profile {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-4);
}

.info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.name {
  font-size: var(--text-sm);
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.email {
  font-size: var(--text-xs);
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.separator {
  height: 1px;
  background: var(--border-subtle);
  margin: var(--space-1) 0;
}
